import { createSlice } from '@reduxjs/toolkit';
import { getModules, upsertModuleWatchProgress } from './moduleThunk';
import { IModuleDetail, UpsertModuleWatchProgressBody } from '~/utils/interface/module';
import { IListDataResponseCanvas } from '~/utils/interface/base';

interface LastProgress extends UpsertModuleWatchProgressBody {
  moduleId: number;
  updatedAt: number;
}

interface ModuleState {
  isPosting: boolean;
  lastProgress?: LastProgress;
  isLoading: boolean;
  modules: IListDataResponseCanvas<IModuleDetail[]> | null;
}

const initialState: ModuleState = {
  isPosting: false,
  lastProgress: undefined,
  isLoading: false,
  modules: null,
};

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(upsertModuleWatchProgress.pending, (state) => {
        state.isPosting = true;
      })
      .addCase(upsertModuleWatchProgress.fulfilled, (state, action) => {
        state.isPosting = false;
        const { moduleId, body } = action.payload;
        state.lastProgress = {
          moduleId,
          courseId: body.courseId,
          lastWatchedSeconds: body.lastWatchedSeconds,
          isWatched: body.isWatched,
          updatedAt: Date.now(),
        };
      })
      .addCase(upsertModuleWatchProgress.rejected, (state) => {
        state.isPosting = false;
      });

    // Get modules
    builder
      .addCase(getModules.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getModules.fulfilled, (state, action) => {
        state.isLoading = false;
        state.modules = action.payload.data;
      })
      .addCase(getModules.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default moduleSlice.reducer;
